import type { SchedulerTechnician } from '@/types/scheduler';

export function findTechnicianByAssignmentId(
  technicians: SchedulerTechnician[] | null | undefined,
  assignmentId: string | null | undefined,
) {
  if (!assignmentId) return undefined;
  return technicians?.find(
    (technician) => technician.id === assignmentId || technician.authUserId === assignmentId,
  );
}

export function hasTechnicianAssignment(
  technicians: SchedulerTechnician[] | null | undefined,
  assignmentId: string | null | undefined,
) {
  return Boolean(findTechnicianByAssignmentId(technicians, assignmentId));
}
